import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';

(function () {
  function hydrateSliderVideos(slider) {
    var videos = slider.querySelectorAll('.wpc--cover--slide video.initVideo');
    if (!videos.length) return;

    var hideDesktopVideo = window.matchMedia('(max-width:1023px), (orientation: portrait)').matches;

    videos.forEach(function (video) {
      var isDesktopOnly = video.classList.contains('initDesktop');
      var sourceUrl = video.getAttribute('data-large') || video.getAttribute('data-mobile');
      if (!sourceUrl) return;

      // Keep behavior aligned with existing initVideo logic on small/portrait.
      if (isDesktopOnly && hideDesktopVideo) {
        video.pause();
        video.querySelectorAll('source').forEach(function (sourceNode) {
          sourceNode.remove();
        });
        return;
      }

      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      var currentSource = video.querySelector('source');
      if (!currentSource) {
        currentSource = document.createElement('source');
        currentSource.className = 'video--source';
        currentSource.type = 'video/mp4';
        currentSource.src = sourceUrl;
        video.appendChild(currentSource);
        video.load();
      } else if (currentSource.getAttribute('src') !== sourceUrl) {
        currentSource.setAttribute('src', sourceUrl);
        video.load();
      }

      var tryPlay = function () {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            // Intentionally ignore autoplay rejections.
          });
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        video.addEventListener('loadeddata', tryPlay, { once: true });
      }
    });
  }

  function ensureLoopSlides(slider) {
    var container = slider.querySelector('.embla__container');
    if (!container) return;

    var originalSlides = Array.prototype.slice.call(container.children).filter(function (node) {
      return !node.hasAttribute('data-embla-clone');
    });
    if (!originalSlides.length) return;

    var minSlidesForLoop = 14;
    var round = 0;

    while (container.children.length < minSlidesForLoop && round < 3) {
      originalSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('data-embla-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        container.appendChild(clone);
      });
      round += 1;
    }
  }

  function initWpcCoverSlider() {
    var slider = document.querySelector('.wpc--cover--slider');
    if (!slider) return;

    // Prevent duplicate init when scripts are re-evaluated.
    if (slider.dataset.emblaInitialized === 'true') return;
    slider.dataset.emblaInitialized = 'true';

    ensureLoopSlides(slider);
    hydrateSliderVideos(slider);

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var embla = EmblaCarousel(
      slider,
      {
        loop: true,
        align: 'start',
        dragFree: true,
        skipSnaps: true,
        containScroll: false,
        watchDrag: false,
      },
      [AutoScroll({
        speed: 1,
        startDelay: 0,
        playOnInit: false,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        stopOnFocusIn: false,
      })]
    );

    slider.classList.add('is-ready');

    function resumeAutoScroll() {
      if (reduceMotion || embla.destroyed) return;
      var autoScroll = embla.plugins().autoScroll;
      if (autoScroll) autoScroll.play(0);
    }

    embla.on('reInit', function () {
      hydrateSliderVideos(slider);
      resumeAutoScroll();
    });

    if (!reduceMotion) {
      resumeAutoScroll();
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (embla.destroyed) return;
        hydrateSliderVideos(slider);
        embla.reInit();
        resumeAutoScroll();
      }, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWpcCoverSlider);
  } else {
    initWpcCoverSlider();
  }
})();
